var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubtractbgMob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307,
    height: 464,
    viewBox: "0 0 307 464",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.808 461.752C287.5 464 281.862 464 270.584 464H220.613C198.885 464 188.022 464 180.744 459.472C174.37 455.505 169.714 449.293 167.697 442.061C165.393 433.805 168.443 423.378 174.543 402.524L190.793 346.969C193.059 336.658 190.793 329.645 188.598 325.233C186.668 321.353 183.587 318.198 179.799 316.221C175.491 313.973 169.852 313.973 158.575 313.973H48.0001C31.1985 313.973 22.7977 313.973 16.3803 310.704C10.7354 307.827 6.14603 303.238 3.26984 297.593C3.05176e-05 291.176 3.05176e-05 282.775 3.05176e-05 265.973V32.9956C3.05176e-05 21.446 9.15527e-05 15.6713 2.19482 11.26C4.1254 7.37967 7.20581 4.22485 10.9948 2.24771C15.3022 3.05176e-05 20.9409 0 32.2184 0H270.584C281.862 0 288 0 293.5 0C300.956 0 307 6.04327 307 13.4991C307 17.9399 307 22.9118 307 28V430.892C307 432.539 307 433.363 306.928 434.404C306.877 435.135 306.725 436.441 306.606 437.165C306.438 438.194 306.325 438.673 306.099 439.629C304.267 447.396 302.495 448.946 300.608 452.74C298.677 456.62 295.597 459.775 291.808 461.752Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtractbgMob);
export default __webpack_public_path__ + "static/media/subtractbg-mob.edd72d80a042d48fe670a38db3043a25.svg";
export { ForwardRef as ReactComponent };